import { render, staticRenderFns } from "./comingSoon.vue?vue&type=template&id=40a33bfc&scoped=true"
import script from "./comingSoon.vue?vue&type=script&lang=js"
export * from "./comingSoon.vue?vue&type=script&lang=js"
import style0 from "./comingSoon.vue?vue&type=style&index=0&id=40a33bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a33bfc",
  null
  
)

export default component.exports